<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ statInspIcon }}</md-icon>
            </div>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method="post">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <label>Select date</label>
                  <md-datepicker v-model="form.reportDate" md-immediately>
                  </md-datepicker>
                </div>
                <div class="md-layout-item md-small-size-100 md-size-30">
                  <md-checkbox v-model="form.isPartial"
                    >Partial/Non Inpsection?</md-checkbox
                  >
                </div>
                <div
                  v-show="form.isPartial"
                  class="md-layout-item md-small-size-100 md-size-70"
                >
                  <md-field>
                    <label>Note</label>
                    <md-input v-model="form.partialNote" type="text"></md-input>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success"
              :disabled="hasSubmit"
              >Submit</md-button
            >
            <md-button class="md-danger" @click="onCancel">Cancel</md-button>
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "create-stat-insp",
  data() {
    return {
      form: {
        plantId: this.$route.params.plantId,
        reportDate: new Date(),
        isPartial: false,
        partialNote: ""
      },
      hasSubmit: false
    };
  },
  created() {
    this.$material.locale.dateFormat = "yyyy-MM-dd";
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon"
    })
  },
  methods: {
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.form.reportDate = moment(this.form.reportDate).format("YYYY-MM-DD");
      this.$store
        .dispatch("stat-insp/createStatInsp", {
          statInsp: this.form
        })
        .then(data => {
          this.$router.push({
            name: "Statutory Inspection",
            params: { statInspId: data.id }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>

<style></style>
